import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import { Observable } from "rxjs";



@Injectable({ providedIn : "root" })
export class ProfileGuard implements CanActivate
{

    constructor(
        private cookie_s: CookieService
    ){}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) : boolean
    {

        let token = this.cookie_s.get('token');

        if ( token )
        {
            return true;
        }
        else
        {
            return false;

        }

    }

}
